import BranchAvecAbonDiag from "./BranchAvecAbonDiag";
import BranchSansAbonDiag from "./BranchSansAbonDiag";
import TableauxList from "./TableauxList";

const Branchementform = ({
  formData,
  errors,
  addBranchement,
  removeBranchement,
  editBranchement,
  branchement,
  openDialog,
  onCloseDialog,
  typeBranchement,
}) => {
  return (
    <div className="space-y-5 mt-8 mb-8">
      {typeBranchement === "sansAbon" && (
        <BranchSansAbonDiag
          addBranchement={addBranchement}
          branchement={branchement}
          open={openDialog}
          onClose={onCloseDialog}
        />
      )}
      {typeBranchement === "avecAbon" && (
        <BranchAvecAbonDiag
          addBranchement={addBranchement}
          branchement={branchement}
          open={openDialog}
          onClose={onCloseDialog}
        />
      )}
      {formData.tableaux.length > 0 && (
        <div>
          <h2>Liste des branchements</h2>
          <TableauxList
            tableaux={formData.tableaux}
            removeBranchement={removeBranchement}
            TypeBranchement={typeBranchement}
            editBranchement={editBranchement}
          />
        </div>
      )}
      {formData.tableaux.length <= 0 && (
        <>
          {errors.branchement && (
            <p className="mt-2 text-sm text-red-600 dark:text-red-500">
              {errors.branchement}
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default Branchementform;
